import { render, staticRenderFns } from "./shiftCard2.vue?vue&type=template&id=0c1f984b&scoped=true&"
import script from "./shiftCard2.vue?vue&type=script&lang=js&"
export * from "./shiftCard2.vue?vue&type=script&lang=js&"
import style0 from "./shiftCard2.vue?vue&type=style&index=0&id=0c1f984b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1f984b",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCheckbox,VContainer,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSheet,VSpacer,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c1f984b')) {
      api.createRecord('0c1f984b', component.options)
    } else {
      api.reload('0c1f984b', component.options)
    }
    module.hot.accept("./shiftCard2.vue?vue&type=template&id=0c1f984b&scoped=true&", function () {
      api.rerender('0c1f984b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/Other/Roster/components/shiftCard2.vue"
export default component.exports